export default __webpack_public_path__ + "static/media/post-10-detail.190b2f82.jpg";